import { Loading } from "../UI";

const LoadingContainer = (props) => {
  const { isLoading, children } = props;
  if (isLoading) {
    return <Loading loading={isLoading} />;
  }
  return <>{children}</>;
};

export default LoadingContainer;
